import { render, staticRenderFns } from "./CLocatorModal.vue?vue&type=template&id=a64ed2f4&"
import script from "./CLocatorModal.vue?vue&type=script&lang=ts&"
export * from "./CLocatorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports